import response from "../response";


const API_URL = "https://api.d-id.com/talks";
const API_TOKEN = process.env.REACT_APP_D_ID;

if (!API_TOKEN) {
    console.error("D-ID API token is missing. Make sure REACT_APP_D_ID is set.");
}


const getVoiceIdentifier = (language='english', gender='male') => {

    const voices = {
        english: {
            male: "en-US-GuyNeural",
            female: "en-US-JennyNeural"
        },
        british: {
            male: "en-GB-RyanNeural",
            female: "en-GB-LibbyNeural"
        },
        spanish: {
            male: "es-ES-AlvaroNeural",
            female: "es-ES-ElviraNeural"
        },
        mexican: {
            male: "es-MX-JorgeNeural",
            female: "es-MX-DaliaNeural"
        },
        french: {
            male: "fr-FR-HenriNeural",
            female: "fr-FR-DeniseNeural"
        },
        german: {
            male: "de-DE-ConradNeural",
            female: "de-DE-KatjaNeural"
        },
        italian: {
            male: "it-IT-DiegoNeural",
            female: "it-IT-ElsaNeural"
        },
        portuguese: {
            male: "pt-BR-AntonioNeural",
            female: "pt-BR-FranciscaNeural"
        },
        chinese: {
            male: "zh-CN-YunyangNeural",
            female: "zh-CN-XiaoxiaoNeural"
        },
        japanese: {
            male: "ja-JP-KeitaNeural",
            female: "ja-JP-NanamiNeural"
        }
    };

    let lang = language!=='' ? language.toLowerCase() : 'english';
    let gen = gender!=='' ? gender.toLowerCase() : 'male';

    if (voices[lang] && voices[lang][gen]) {
        return voices[lang][gen];
    } else {
        console.error("Voice not found for the given language and gender.");
        return null;
    }
}


export const getTalk = (clone, textInput = "", imageUrl = "https://bardo.vercel.app/images/avatar/3.jpg") => {

    return new Promise(async (resolve, reject) => {

        //resolve(response) 

        let image = imageUrl;

        if (imageUrl?.length) {
            const hasExtension = /\.(png|jpg|jpeg|gif|webp|svg)$/i.test(imageUrl);
            image = hasExtension ? imageUrl : `${imageUrl}.jpg`;
            if (image.startsWith('http://')) {
                image = image.replace('http://', 'https://');
            }
        }

        setTimeout(async()=>{
            try {
                const requestData = {
                    source_url: image,
                    script: {
                        type: "text",
                        input: textInput,
                        provider: {
                            type: "microsoft",
                            voice_id: getVoiceIdentifier(clone?.language, clone?.gender),
                            style: "excited"
                        }
                    },
                    config: {
                        streaming: true
                    }
                };

    
                const postResponse = await fetch(API_URL, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Basic ${API_TOKEN}`
                    },
                    body: JSON.stringify(requestData)
                });
    
    
                console.log("RESP ---> ", postResponse)
    
                if (!postResponse.ok) {
                    return resolve(`Error creating talk: ${postResponse.status} - ${postResponse.statusText}`);
                }
    
                const postData = await postResponse.json();
                const talkId = postData.id;
                let attempts = 0;
                const maxAttempts = 20;
    
                const checkStatus = async () => {
                    if (attempts >= maxAttempts) {
                        return reject("Talk generation timeout.");
                    }
    
                    await new Promise((res) => setTimeout(res, 2000));
                    const getResponse = await fetch(`${API_URL}/${talkId}`, {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Basic ${API_TOKEN}`
                        }
                    });
    
                    if (!getResponse.ok) {
                        return reject(`Error fetching talk details: ${getResponse.status} - ${getResponse.statusText}`);
                    }
    
                    const talkDetails = await getResponse.json();
    
                    if (talkDetails.status === "done") {
                        return resolve(talkDetails);
                    } else if (talkDetails.status === "failed") {
                        return reject("Talk generation failed.");
                    } else {
                        attempts++;
                        checkStatus();
                    }
                };
    
                checkStatus();
            } catch (error) {
                return reject(error);
            }
        },300)

    });
};
